import { DatePipe } from '@angular/common';
import { AfterContentChecked, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ClipboardService } from 'ngx-clipboard';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppointmentServiceDetails } from 'projects/Administration/src/app/business-entities/appointment-service-details-view-model';
import { AppointmentDetail } from 'projects/Administration/src/app/business-entities/appointmentDetail-model';
import { AppointmentList } from 'projects/Administration/src/app/business-entities/appointmentList-model';
import { AppointmentStatus, DocumentPartStatus } from 'projects/Administration/src/app/business-entities/appointmentStatus-model';
import { BrandViewModel } from 'projects/Administration/src/app/business-entities/brand-view-model';
import { DealerViewModel } from 'projects/Administration/src/app/business-entities/dealer-view-model';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import { AppointmentWorkOrderService } from 'projects/Administration/src/app/business-services/appointment-work-order.service';
import { CustomerService } from 'projects/Administration/src/app/business-services/customer.service';
import { DealerBusinessService } from 'projects/Administration/src/app/business-services/dealer.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { SettingService } from 'projects/Administration/src/app/business-services/setting.service';
import { VehicleBusinessService } from 'projects/Administration/src/app/business-services/vehicle-service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { AppointmentGenericTabs, Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Subscription } from 'rxjs';
import * as Enums from '../../../../../../../Autofacets-Core/src/app/utils/enums';
import { AppointmentService } from '../../../../business-services/appointment.service';
import { ViewCustomerComponent } from '../../../customer/view-customer/view-customer.component';
import { EditVehicleComponent } from '../../../vehicle/edit-vehicle/edit-vehicle.component';
import { UserRoleMenu } from 'projects/Administration/src/app/business-entities/user-role-menu.model';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { AppointmentCommonService } from 'projects/Administration/src/app/business-services/appointment-common.service';
import { OnholdStatusChangeComponent } from 'projects/Administration/src/app/components/onhold-status-change/onhold-status-change.component';
import { CancelStatusChangeComponent } from 'projects/Administration/src/app/components/cancel-status-change/cancel-status-change.component';
import { AppointmentType } from '../../../../../../../Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { AppLinkService } from 'projects/Administration/src/app/business-services/app-link.service';
import { WorkOrderServicesComponent } from './work-order-services/work-order-services.component';
import { WorkOrderCustomerDetailsComponent } from './work-order-customer-details/work-order-customer-details.component';
import { MultiStackPopupService } from 'projects/Administration/src/app/services/multi-stack-popup.service';

@Component({
  selector: 'app-appointment-work-order',
  templateUrl: './appointment-work-order.component.html',
  styleUrls: ['./appointment-work-order.component.css']
})
export class AppointmentWorkOrderComponent implements OnInit, AfterContentChecked, OnDestroy {
  statusList: AppointmentStatus[];
  documentPartStatus: DocumentPartStatus[];
  openPanels: Array<string> = ['first', 'forth'];
  contactDetails: AppointmentDetail;
  appointmentDetails: AppointmentList;
  serviceDetail: AppointmentServiceDetails;
  statusTrackerUrl: any;
  brandList: BrandViewModel[];
  createdDate: any;
  @Input() isViewAppointmentFromWAR: boolean; 
  formattedTotalTime: string;
  licensePlateClass: string;
  appointmentStatusName: string;
  SelectedStatus: any = null;
  SelectedDocumentPartStatus: any = null;
  currentlagSub: Subscription;
  StatusDisabled: boolean = false;
  previousStatus: any;
  previousDocumentStatus: any;
  appointmentBookedDate: any;
  appointmentCreatedDate: any;
  appointmentUpdatedDate: any;
  appointmentPKKDate: any;
  features: Features[] = [];
  SelectedSalesPerson: any = null;
  RentalCarModel: any;
  RentalCarPrice: any;
  isRentalCar: boolean = false;
  genericRentalCar: boolean = false;
  isCurrentAppointmentOnHold: boolean = false;
  popupCloseResult = false;
  isShowGenerateTrackerButton: boolean = false;
  isDocumentPartStatusActive: boolean = false;
  remark: string = '';
  _isBnh: boolean = false;
  _isMg: boolean = false;
  _isAfx: boolean = false;
  salesPersonList = []
  @Output() showPdf = new EventEmitter<number>();
  updatedAppointmentValues: any;
  StartDate;
  AppointmentHour: number;
  AppointmentMinutes: number;
  BookingDatetime: Date;
  IsDisableBookedDate: boolean = true;
  featureList: Features[] = [];
  isRentalService: boolean = false;
  isShiftAppointment: boolean = false;
  offerType: string;
  isQuote: boolean = false;
  VAT: number = 0;
  VatSub: Subscription;
  IsonHoldStatus: boolean = false;
  dealers: DealerViewModel[] = [];
  @ViewChild("AppointmentminuteInput") AppointmentminuteInput: ElementRef;
  @ViewChild("workOrderServices") workOrderServicesComponent: WorkOrderServicesComponent;
  @ViewChild("workOrderCustomerDetails") workOrderCustomerDetails!: WorkOrderCustomerDetailsComponent;
  @Output() onGetContactDetails = new EventEmitter<AppointmentDetail>();
  @Output() isRefreshTab = new EventEmitter<boolean>();
  @Output() onShiftAppointment = new EventEmitter<any>();
  IsActive: boolean = true;
  shiftDealerId: string;
  isDMSEnable: boolean = false;
  isGiftCardActive: boolean = false;
  isToAddRentalCarAsDemand: boolean = false;
  userRoleRightsDetails: UserRoleMenu;
  userRoleRightsDetailsVehicle: UserRoleMenu;
  @Output() closeFromAppiontmentWO = new EventEmitter<boolean>();
  @Input() isOpenFromPlanning: boolean = false;
  isSaving: boolean = false;

  constructor(private readonly appointmentService: AppointmentService,
    public editAppointmentService: EditAppointmentService,
    private readonly spinner: NgxSpinnerService,
    public settingService: SettingService,
    public workOrderService: AppointmentWorkOrderService,
    private readonly toastr: ToastrService,
    private readonly translate: TranslateService,
    private readonly cookieservice: CookieService,
    private readonly globalSetting: GlobalSetting,
    private readonly modalService: NgbModal,
    private readonly clipboardApi: ClipboardService,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly cdref: ChangeDetectorRef,
    private readonly activeModal: NgbActiveModal,
    private readonly secureStorage: SecureStorage,
    public dealerBusinessService: DealerBusinessService,
    private readonly datePipe: DatePipe,
    private readonly serviceCustomer: CustomerService,
    private readonly serviceVehicle: VehicleBusinessService,
    private readonly userService: UserDataService,
    public commonService: AppointmentCommonService,
    private readonly appLinkService: AppLinkService,
    private readonly multiStackPopupService: MultiStackPopupService
  ) { }

  ngOnInit(): void {
    let clientName = localStorage.getItem("Theme");
    if (clientName == 'bnh') {
      this._isBnh = true;
    } else if (clientName == 'mg') {
      this._isMg = true;
    } else {
      this._isAfx = true;
    }
    this.isCurrentAppointmentOnHold = false;
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.Customer);
    this.userRoleRightsDetailsVehicle = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find((menu) => menu.moduleId === Enums.ModuleNames.Vehicle);
    if (this.editAppointmentService.appointmentDetails?.workOrderStatusId) {
      this.previousStatus = this.editAppointmentService.appointmentDetails.workOrderStatusId;
      this.previousDocumentStatus = this.editAppointmentService.appointmentDetails.documentPartStatus;
      this.SelectedDocumentPartStatus = this.editAppointmentService.appointmentDetails.documentPartStatus;
    }
    if (this.secureStorage.getKeyData('feature')) {
      this.featureList = this.secureStorage.getKeyData('feature');
      if (this.featureList?.length > 0) {
        this.isRentalService = this.featureList.find(x => x.featureCode === Enums.FeatureCode.RenatlCar)?.isActive
        this.genericRentalCar = this.featureList.find(x => x.featureCode === Enums.FeatureCode.GRentalCar)?.isActive;
        this.isDocumentPartStatusActive = this.featureList.find(x => x.featureCode === Enums.FeatureCode.DocumentPartStatus)?.isActive;
        this.isShiftAppointment = this.featureList.find(x => x.featureCode === Enums.FeatureCode.ShiftAppointment)?.isActive;
        this.isDMSEnable = this.featureList.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
        this.isGiftCardActive = this.featureList.find(x => x.featureCode === Enums.FeatureCode.GiftCard)?.isActive;
        this.isToAddRentalCarAsDemand = this.featureList.find(x => x.featureCode === Enums.FeatureCode.RentalCarAsDemand)?.isActive;
      }
    }
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.GetAll();
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.getStatusBrand(this.editAppointmentService.appointmentDetails.dealerId, this.editAppointmentService.appointmentDetails.id, x);
    });
    this.GetServiceDetail();
    this.VatSub = this.currentLanguageService.vatSubject.subscribe(x => {
      this.VAT = x;
    })
    this.editAppointmentService.isEdit = this.getEditStatusofAppointment(this.editAppointmentService.appointmentDetails.workOrderStatusId);
    this.cdref.detectChanges();
  }
  ngOnDestroy(): void {
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
    this.workOrderService.totalPrice = null;
    this.workOrderService.totalTime = null;
    this.workOrderService.totalInvoicePrice = null;
  }


  CheckAppointmentMinute(_e) {
    if (this.AppointmentMinutes >= 60) {
      this.AppointmentMinutes = 59;
    }
  }

    @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 's') {
      event.preventDefault();     
      this.SaveAppointmentData();                
    }
  }
  generateTrackerLink() {
    if (this.commonService.appointmentBookedDate) {
      if (this.editAppointmentService.trackerURL) {
        let warningMessage = this.translate.instant("lblTrackerLinkAlreadyGenerated");
        this.toastr.warning(warningMessage);
      }
      else {
        let data = {
          AppointmentGuid: this.editAppointmentService.appointmentDetails.appointmentGuid
        }
        this.generateStatusTrackerLink(data);
      }
    }
    else {
      let failedMessage = this.translate.instant("lblPleaseAddAppointmentPlanning");
      this.toastr.error(failedMessage);
    }
  }

  async generateAndSendTrackerLink() {
    if (this.commonService.appointmentBookedDate) {
      let isTrackerLinkGenerated = false;
      if (!this.editAppointmentService.trackerURL) {
        let data = {
          AppointmentGuid: this.editAppointmentService.appointmentDetails.appointmentGuid
        }
        this.generateStatusTrackerLink(data);
        isTrackerLinkGenerated = true;
      }
      await this.appLinkService.SendTrackerSms(this.editAppointmentService.appointmentDetails.appointmentGuid).then(_x => {
        if (_x === "true" && isTrackerLinkGenerated) {
          let successMessage = this.translate.instant("lblTrackerLinkIsGeneratedAndMessageSent");
          this.toastr.success(successMessage);
        }
        else {
          let failMessage = this.translate.instant("lblFailedToSentTrackerLink");
          this.toastr.error(failMessage);
        }

      }, _error => {
        console.error('HTTP Error', _error);
      })
    }
    else {
      let failedMessage = this.translate.instant("lblPleaseAddAppointmentPlanning");
      this.toastr.error(failedMessage);
    }
  }

  onSelectOnHoldStatus() {
    const modalref = this.modalService.open(OnholdStatusChangeComponent,
      { size: 'lg', windowClass: 'pop-wid800 ' });
    //if 2 then it is car arrived
    modalref.componentInstance.currentWorkorderStatusId = this.appointmentDetails.workOrderStatusId;
    modalref.componentInstance.appointmentId = this.editAppointmentService.appointmentDetails.id;
    modalref.componentInstance.workOrderNumber = this.contactDetails.workOrderNo;
    modalref.result.then((response) => {
      //status update
      if (response.success && response.isKeepOnHold === true) {
        this.isRefreshTab.emit(true);
        this.resetCalculations()
      }
      //remove selected on hold status
      else {
        this.resetCalculations()
      }
    }, _error => {
      // This is intentional
    });
  }
  OnSelectCancelStatus() {
    const modalref = this.modalService.open(CancelStatusChangeComponent,
      { size: 'lg', windowClass: 'pop-wid800 ' });
    //if 2 then it is car arrived
    modalref.componentInstance.appointmentId = this.editAppointmentService.appointmentDetails.id;
    modalref.componentInstance.workOrderNumber = this.contactDetails.workOrderNo;
    modalref.componentInstance.appointmentType = this.appointmentDetails.appointmentType;
    modalref.componentInstance.appointmentGuid = this.editAppointmentService.appointmentDetails.appointmentGuid;
    modalref.componentInstance.brandCode = this.commonService.appointmentDetails.brandCode;
    modalref.result.then((response) => {
      //status update
      if (response.success && response.isKeepOnHold === true) {
        this.isRefreshTab.emit(true);
        this.resetCalculations()
      }
      //remove selected on hold status
      else {
        this.resetCalculations()
      }
    }, _error => {
      // This is intentional
    });
  }
  onStatusChange() {
    if (this.SelectedStatus != null || this.SelectedStatus != undefined) {
      if (this.SelectedStatus === Enums.WOStatus.OnHold) {
        this.onSelectOnHoldStatus()
      } else if (this.SelectedStatus === Enums.WOStatus.Cancelled) {
        this.OnSelectCancelStatus()
      }
      this.appointmentDetails.workOrderStatusId = this.SelectedStatus;
    }
  }

  private getDismissDeleteReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  onSelectImportedCarCheckBox(event) {
    this.contactDetails.importedCar = event;
  }
  onDocumentPartStatusChange() {
    this.appointmentDetails.documentPartStatus = this.SelectedDocumentPartStatus;
  }
  ngAfterContentChecked(): void {
    this.cdref.detectChanges();
  }
  copyTextEUControl() {
    this.clipboardApi.copyFromContent(this.datePipe.transform(this.appointmentPKKDate, 'dd-MM-yyyy HH:mm:ss'))
  }
  copyTextStatusTrackerUrl() {
    this.clipboardApi.copyFromContent(this.statusTrackerUrl)
  }
  resetCalculations() {
    this.SelectedStatus = null;
    this.appointmentDetails.workOrderStatusId = this.previousStatus;
  }
  resetDocumetStatus() {
    this.SelectedDocumentPartStatus = null;
    this.appointmentDetails.documentPartStatus = null;
  }
  copyVINText() {
    this.clipboardApi.copyFromContent(this.appointmentDetails.chassisNo)
  }
  getStatusBrand(dealerId: string, appointmentId: number, languageCode: string) {
    this.commonService.getStatusBrand(dealerId, appointmentId, languageCode).then(res => {
      if (this.editAppointmentService.appointmentDetails?.appointmentGuid) {
        this.GetAppointmentDetail(this.editAppointmentService.appointmentDetails.id, this.editAppointmentService.appointmentDetails.appointmentGuid);
      }
    })
  }

  updateService(serviceDetail) {
    this.serviceDetail = serviceDetail;
  }

  openNewAppointment(newAppointemntId) {
    this.CheckDataSyncedOnAppointment('close');
  }

  async checkForSaveAppointment() {
    let newDemandIndex = this.serviceDetail.appointmentDemandList.filter(x=>!x.isInWarranty).findIndex(x => (!x.id || x.id === 0));
    if (newDemandIndex >= 0) {
      await this.SaveAppointmentData();
    }
    this.workOrderServicesComponent.openSplitOrderPopup();
  }

  async GetServiceDetail() {
    const languageCode = this.cookieservice.get('userSelectedLanguage');
    await this.appointmentService.GetServiceDetail(this.editAppointmentService.appointmentDetails.id, '', languageCode).then(data => {
      if (data.responseObject?.errorCount > 0) {
        this.serviceDetail = {
          totalPrice: 0,
          totalTime: 0,
          totalInvoicePrice: 0,
          priceForDisply: '',
          rentalCompanyMakeName: '',
          appointmentDemandList: [],
          appointmentJobDetailList: [],
          appointmentJobList: [],
          appointmentPriceDetails: [],
          isFromArchive: false
        }
        this.workOrderService.totalPrice = null;
        this.workOrderService.totalTime = null;
        this.workOrderService.totalInvoicePrice = null;
      }
      else {

        this.serviceDetail = data.responseObject;
        this.mapIndexWithJobDetails();
        this.serviceDetail.isFromArchive = this.editAppointmentService.appointmentDetails.isFromArchive;
        this.workOrderService.appointmentDemandList = this.serviceDetail.appointmentDemandList;
        this.workOrderService.appointmentJobList = this.serviceDetail.appointmentJobList;
        this.workOrderService.appointmentJobDetailList = this.serviceDetail.appointmentJobDetailList;
        this.workOrderService.totalPrice = 0;
        this.workOrderService.totalPriceInclVAT = 0;
        this.workOrderService.totalInvoicePrice = 0;
        this.workOrderService.totalTime = this.serviceDetail.totalTime;

        if (this.serviceDetail.taxDetail) {
          this.workOrderService.taxDetail = this.serviceDetail.taxDetail;
          this.workOrderService.totalPrice = this.serviceDetail.taxDetail.totalPriceInclTAX;
          this.workOrderService.totalInvoicePrice = this.serviceDetail.taxDetail.totalInvoicePrice;
          this.workOrderService.totalPriceInclVAT = this.serviceDetail.taxDetail.totalPriceInclVAT;
          this.workOrderService.totalPriceToDisplay = this.serviceDetail.taxDetail.totalPriceToDisplay;
          this.workOrderService.getOverallAmountForAppointment();
        }
        this.formattedTotalTime = Number(this.workOrderService.totalTime).toFixed(2);

        this.workOrderService.appointmentJobDetailToUpdate = this.serviceDetail.appointmentJobDetailList.slice();
        this.addFilterSelectedVariable(false);
        this.GetDocumentCount();
      }

    })
  }
  mapIndexWithJobDetails() {
    let index = 1;
    let demand = 1;
    this.serviceDetail.appointmentJobDetailList.forEach((jobDetails) => {
      if (jobDetails.jobId == jobDetails.demandNo && jobDetails.demandNo == demand) {
        jobDetails.jobDetailsId = index;
        demand = jobDetails.demandNo;
        index++;
      } else {
        index = 1;
        jobDetails.jobDetailsId = index;
        demand = jobDetails.demandNo;
        index++;
      }
    })
  }


  confirmRefresh(isForCustomerDetail, e: Event) {
    e.stopPropagation();
    let modelHeadermsg = this.translate.instant("lblConfirmation");
    let modelBodymsg;
    modelBodymsg = this.translate.instant("lblRefreshAlert");
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {

    }, (reason) => {
      this.popupCloseResult = this.getDismissDeleteReason(reason);
      if (this.popupCloseResult) {
        if (isForCustomerDetail) {
          this.customerRefreshData();
        }
        else {
          this.vehicleRefreshData();
        }
      }
    })
  }
  onRefreshCustomer() {
    this.customerRefreshData();
    this.workOrderServicesComponent?.getCustomerList();
  }
  customerRefreshData() {
    this.spinner.show();
    this.appointmentService.RefreshCustomerData(this.editAppointmentService.appointmentDetails.id, this.isDMSEnable).then((res) => {
      this.spinner.hide();
      if (res.responseObject) {
        let successMessage = this.translate.instant("lblDataReplacedWithExistingInformationSuccssfully");
        this.toastr.success(successMessage);
        this.GetAppointmentDetail(this.editAppointmentService.appointmentDetails.id, this.editAppointmentService.appointmentDetails.appointmentGuid);
      } else {
        let errorMessage = this.translate.instant("lblDataReplaceWithExistingInformationFailed");
        this.toastr.error(errorMessage);
      }
    }, _error => {
      this.spinner.hide()
    });
  }
  vehicleRefreshData() {
    this.spinner.show();
    this.appointmentService.RefreshVehicleData(this.editAppointmentService.appointmentDetails.id, this.isDMSEnable).then((res) => {
      this.spinner.hide();
      if (res.responseObject) {
        let successMessage = this.translate.instant("lblDataReplacedWithExistingInformationSuccssfully");
        this.toastr.success(successMessage);
        this.GetAppointmentDetail(this.editAppointmentService.appointmentDetails.id, this.editAppointmentService.appointmentDetails.appointmentGuid);
      } else {
        let errorMessage = this.translate.instant("lblDataReplaceWithExistingInformationFailed");
        this.toastr.error(errorMessage);
      }
    }, _error => {
      this.spinner.hide()
    });
  }

  async GetDocumentCount() {
    await this.appointmentService.GetDocumentCount(this.editAppointmentService.appointmentDetails.id).then(data => {
      let demands = data.responseObject;
      this.editAppointmentService.DemandWiseDocumentCountList = data.responseObject;
      if (demands?.length > 0) {
        demands.forEach(element => {
          if (this.serviceDetail.appointmentDemandList?.length > 0) {
            this.serviceDetail.appointmentDemandList?.forEach(x => {
              if (x?.id == element.demandId) {
                x.docCount = element.docCount;
              }
            })
          }
        });
        this.workOrderService.appointmentDemandList = this.serviceDetail.appointmentDemandList;
      }
    })
  }


  addFilterSelectedVariable(toSelect: boolean) {
    this.serviceDetail.appointmentDemandList.forEach((obj) => {
      obj.isFilterSelected = toSelect;
    });
    this.serviceDetail.appointmentJobList.forEach((obj) => {
      obj.isFilterSelected = toSelect;
      let jobDetails = this.serviceDetail.appointmentJobDetailList?.find((detail) => detail.jobId == obj.jobId && detail.costType == 'Personnel');
      if (jobDetails != null || jobDetails != undefined) {
        obj.isServiceAdded = true;
      }
    });
  }

  async GetAll() {
    this.appointmentDetails = this.editAppointmentService.appointmentDetails;
    if (this.appointmentDetails?.workOrderStatusId) {
      if (this.appointmentDetails.workOrderStatusId === Enums.WOStatus.Closed || this.appointmentDetails.workOrderStatusId === Enums.WOStatus.Cancelled) {
        this.SelectedStatus = this.appointmentDetails.workOrderStatusId;
        this.StatusDisabled = true;
      }
      else {
        this.SelectedStatus = null;
      }
    }
    if (this.editAppointmentService.appointmentDetails.appointmentType == "Quote") {
      this.isQuote = true;
    }
    this.appointmentStatusName = this.appointmentDetails.appointmentStatus;
    this.SelectedDocumentPartStatus = this.appointmentDetails.documentPartStatus;
  }

  async GetAppointmentDetail(Id: number, Guid: string) {
    this.spinner.show();
    this.commonService.GetAppointmentDetail(Id).then((result) => {
      if (result != null) {
        this.spinner.hide();
        this.contactDetails = result;
        this.onGetContactDetails.emit(result);
        if(this.workOrderCustomerDetails)
        {
          this.workOrderCustomerDetails.contactDetails.billToCustomerMobileCode = this.contactDetails.billToCustomerMobileCode;
          this.workOrderCustomerDetails.contactDetails.customerMobileCode = this.contactDetails.customerMobileCode;
          this.workOrderCustomerDetails.setDialCodes();
        }
      }
    },
      _error => {
        this.spinner.hide()
      });
  }

  refreshTab(event: any) {
    if (event) {
      this.isRefreshTab.emit(true);
    }
  }

  public onRefresh() {
    this.onShiftAppointment.emit();
  }

  onGetContactDetail(contactDetails: any) {
    this.contactDetails = contactDetails;
    this.onGetContactDetails.emit(contactDetails);
  }

  togglePanel(id: string): void {
    id = id.toString();
    const index = this.openPanels.findIndex(x => x === id);
    if (index > -1) {
      this.openPanels.splice(index, 1);

    }
    else {
      this.openPanels.push(id);
    }

  }

  updateAppointmentValues(event: any) {
    this.contactDetails = event.updatedAppointmentValues;
    this.workOrderService.selectedRentalCarDetail = event.selectedRentalCarDetail;
    this.isRentalCar = this.contactDetails.isRentalCarSelected;
    if (this.isToAddRentalCarAsDemand && this.isRentalCar) {
      this.AddRentalCarAsDemand();
    }
  }

  unselectRentalCar(isRentalCarSelected: boolean) {
    if (this.isToAddRentalCarAsDemand) {
      if (!isRentalCarSelected) {
        let isReload = false;
        const rentalCarDemandIndex = this.serviceDetail.appointmentDemandList?.findIndex(x => x.isRentalCarDemand);
        const demandId = this.serviceDetail.appointmentDemandList[rentalCarDemandIndex].id;
        if (demandId == 0) {
          if (this.serviceDetail.appointmentJobList.length !== 0 && rentalCarDemandIndex < this.serviceDetail.appointmentJobList.length) {
            let demandNo = this.serviceDetail.appointmentJobList[rentalCarDemandIndex].demandNo;
            if (demandNo) {
              this.serviceDetail.appointmentDemandList.splice(rentalCarDemandIndex, 1);
              this.serviceDetail.appointmentJobList.splice(rentalCarDemandIndex, 1);
            }
            else {
              this.serviceDetail.appointmentDemandList.splice(rentalCarDemandIndex, 1);
            }
          }
          else {
            this.serviceDetail.appointmentDemandList.splice(rentalCarDemandIndex, 1);
          }
        }
        else {
          this.workOrderService.appointmentDemandList[rentalCarDemandIndex].isDeleted = true;
          this.workOrderService.appointmentJobList[rentalCarDemandIndex].isDeleted = true;
          isReload = true;
        }
        if (isReload) {
          this.workOrderServicesComponent.DeleteAndGetJobDetails();
        }
      }
    }
  }

  AddRentalCarAsDemand() {
    const existingRentalCarDemandIndex = this.serviceDetail.appointmentDemandList?.findIndex(x => x.isRentalCarDemand);
    if (existingRentalCarDemandIndex >= 0) {
      this.serviceDetail.appointmentDemandList[existingRentalCarDemandIndex].customerRequirement = this.workOrderService.selectedRentalCarDetail.makeName + ' ' + this.workOrderService.selectedRentalCarDetail.model;
      this.serviceDetail.appointmentDemandList[existingRentalCarDemandIndex].fixedPrice = this.workOrderService.selectedRentalCarDetail.price;
      this.serviceDetail.appointmentDemandList[existingRentalCarDemandIndex].totalPriceInclVAT = this.workOrderService.selectedRentalCarDetail.price;
    } else {
      let demandNo = 1;
      if (this.serviceDetail.appointmentDemandList.length == 0) {
        this.serviceDetail.appointmentDemandList.push({
          id: 0,
          demandNo: demandNo,
          shortDescription: "Rental Car",
          customerRequirement: this.workOrderService.selectedRentalCarDetail.makeName + ' ' + this.workOrderService.selectedRentalCarDetail.model,
          preApproval: "",
          isAddedFromAdmin: true,
          isRentalCarDemand: true,
          isInWarranty: false,
          isDeleted: false,
          fixedPrice: this.workOrderService.selectedRentalCarDetail.price,
          sumPerService: 0,
          sumPerServiceInclTax: 0,
          sentForCustomerApproval: false,
          customerReply: null,
          isAdditionalWork: false,
          totalPriceInclVAT: this.workOrderService.selectedRentalCarDetail.price,
          sumPerServiceWithoutDiscountInclVAT: 0,
          billToCustomer: this.contactDetails.billtoCustomerNo,
          docCount: 0,
          sstOperationId: '',
          sstOperationCode: '',
          demandStaus: ''
        });
      }
      else {
        if (!this.empty(this.serviceDetail.appointmentDemandList[this.serviceDetail.appointmentDemandList?.length - 1]?.shortDescription)) {
          let lastDemandNo: any = this.serviceDetail.appointmentDemandList[this.serviceDetail.appointmentDemandList.length - 1].demandNo;
          demandNo = lastDemandNo + 1;
          this.serviceDetail.appointmentDemandList.push({
            id: 0,
            demandNo: +demandNo,
            shortDescription: "Rental Car",
            customerRequirement: this.workOrderService.selectedRentalCarDetail.makeName + ' ' + this.workOrderService.selectedRentalCarDetail.model,
            preApproval: "",
            isAddedFromAdmin: true,
            isRentalCarDemand: true,
            isInWarranty: false,
            isDeleted: false,
            fixedPrice: this.workOrderService.selectedRentalCarDetail.price,
            sumPerService: 0,
            sumPerServiceInclTax: 0,
            sumPerServiceWithoutDiscountInclVAT: 0,
            sentForCustomerApproval: false,
            customerReply: null,
            isAdditionalWork: false,
            totalPriceInclVAT: this.workOrderService.selectedRentalCarDetail.price,
            billToCustomer: this.contactDetails.billtoCustomerNo,
            docCount: 0,
            sstOperationId: '',
            sstOperationCode: '',
            demandStaus: ''
          });
        }
        else {
          let msg = this.translate.instant("lblShortDescriptionNotNull")
          this.toastr.error(msg);
        }
      }

      this.serviceDetail.appointmentJobList.push({
        id: 0,
        demandNo: demandNo,
        jobId: demandNo,
        description: 'Rental Car',
        appointmentDemandId: 0,
        fixedPrice: this.workOrderService.selectedRentalCarDetail.price,
        price: this.workOrderService.selectedRentalCarDetail.price,
        salesPriceWithoutDiscountInclVAT: this.workOrderService.selectedRentalCarDetail.price,
        totalTime: 0,
        isAddedFromAdmin: true,
        isAdditionalWork: true,

      });
    }
  }
  /**
   * The tel-input models may hold either a plain string or the control's own ChangeData
   * object (possibly nested), depending on whether the user touched the field. Accept both
   * so saving never blanks out an untouched number.
   */
  private getPhoneNumberString(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    const number = typeof value === 'string' ? value : this.getPhoneNumberString(value.number);
    return number.toString().replace(/\s+/g, '');
  }

  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }

  async SaveAppointmentData(isclose = false) {
    const appointmentId = this.editAppointmentService.appointmentDetails.id;
    // Prevent duplicate calls - also blocks while a WorkOrderServicesComponent auto-save
    // (Add/Delete Service) for this same appointment is still in flight, since that fires
    // its own UpdateAppointment call outside this method's isSaving guard.
    if (this.isSaving || this.workOrderService.isSavingAppointment(appointmentId)) {
      return;
    }
    this.isSaving = true;
    this.workOrderService.beginSave(appointmentId);
    try {

    // On click on save btn
    this.spinner.show();
    if (this.isQuote && this.editAppointmentService.appointmentDetails.appointmentType == "Quote" && this.SelectedStatus == Enums.WOStatus.Cancelled) {
      // nothing validaion.
    } else {
      if (this.isDocumentPartStatusActive && (this.editAppointmentService.appointmentDetails.documentPartStatus == null || this.editAppointmentService.appointmentDetails.documentPartStatus == undefined
        || this.appointmentDetails.documentPartStatus == null || this.appointmentDetails.documentPartStatus == undefined || this.appointmentDetails.documentPartStatus == "") && !this.editAppointmentService.isExported) {
        let msg = this.translate.instant("lblSelectDocumentStatus")
        this.toastr.error(msg);
        this.spinner.hide();
        this.isSaving = false;
        return;
      }
      let AddMechanicsMessage = this.translate.instant("lblAddMechanicsMessage");
      if (this.contactDetails != undefined) {
        if ((this.contactDetails.plannedMechanics == null || this.contactDetails.plannedMechanics == undefined || this.contactDetails.plannedMechanics == '') && this.commonService.SelectedStatus?.toString() == Enums.WorkOrderStatus.MechanicStarted) {
          this.resetCalculations();
          this.resetDocumetStatus();
          this.appointmentDetails.workOrderStatusId = this.previousStatus;
          this.appointmentDetails.documentPartStatus = this.previousDocumentStatus;
          this.toastr.warning(AddMechanicsMessage);
          this.spinner.hide();
          this.isSaving = false;
          return;
        }
      }
      if (this.documentPartStatus && this.documentPartStatus?.length > 0) {
        let id = this.documentPartStatus.find(x => x.code == this.appointmentDetails.documentPartStatus)?.rowId
        this.appointmentDetails.documentPartStatusId = (id === undefined ? 0 : id);
      }
      if (this.workOrderService.isDiscountError) {
        let errorMessage = this.translate.instant("lblDiscountValidation");
        this.toastr.error(errorMessage);
        this.spinner.hide();
        this.isSaving = false;
        return;
      }
      if (!this.isQuote && ((this.contactDetails.kilometer == null || this.contactDetails.kilometer == undefined) && !this.editAppointmentService.isExported)) {
        let errorMessage = this.translate.instant("lblMileageRequired");
        this.toastr.error(errorMessage);
        this.spinner.hide();
        this.isSaving = false;
        return;
      }
      if(this.commonService.contactDetails.campaignServiceId == 3 && (this.commonService.contactDetails.campaignServiceText == null || this.commonService.contactDetails.campaignServiceText == undefined || this.commonService.contactDetails.campaignServiceText == "")){
        let errorMessage = this.translate.instant("lblAddCampaignText");
        this.toastr.error(errorMessage);
        this.spinner.hide();
        this.isSaving = false;
        return;
      }
      // Commenting this code as per discussion with samir sir on 19-Apr-2023 Task6358
      // if(+this.contactDetails.kilometer===+this.contactDetails.previousKilometer && !this.editAppointmentService.isExported)
      // {
      //   let warningMessage = this.translate.instant("lblMileageSameAsPreviousMileage");
      //   this.toastr.warning(warningMessage);
      // }
      if (!this.isQuote && (+this.contactDetails.kilometer < +this.contactDetails.previousKilometer && !this.editAppointmentService.isExported)) {
        let errorMessage = this.translate.instant("lblMileageShouldBeGreaterThanPreviousValue");
        errorMessage = errorMessage + ' ' + this.contactDetails.previousKilometer + ' KM'
        this.toastr.warning(errorMessage);
        this.spinner.hide();
        this.isSaving = false;
      }
    }
    this.workOrderService.isUpdateAppointment = true;
    if (this.StartDate) {
      this.BookingDatetime = this.calculateDateTime(this.StartDate, this.AppointmentHour, this.AppointmentMinutes);
      this.workOrderService.BookingDatetime = this.BookingDatetime;
    }
    this.workOrderService.contactDetails.mobileNo = this.getPhoneNumberString(this.commonService.mobileNo);
    this.workOrderService.contactDetails.singlePhoneNo = this.getPhoneNumberString(this.commonService.singlePhoneNo);
    let viewModel = this.workOrderService.MapToViewModel(true, false);
    if (viewModel.FinishedTime != null) {
      if (viewModel.FinishedTime <= viewModel.DeliveryTime) {
        let statusUpdateError = this.translate.instant("lblFinishedTimeGreaterThenDeliveryTime");
        this.toastr.error(statusUpdateError);
        this.spinner.hide();
        this.isSaving = false;
        return;
      }
      if (viewModel.DeliveryTime == null) {
        let statusUpdateError = this.translate.instant("lblDeliveryTimeMustBeRequired");
        this.toastr.error(statusUpdateError);
        this.spinner.hide();
        this.isSaving = false;
        return;
      }
    }
    if (this.SelectedStatus != null) {
      if (this.editAppointmentService.appointmentDetails.appointmentType != "Quote" && (this.BookingDatetime == null)) {
        let statusUpdateError = this.translate.instant("lblStatusCanNotBeChange");
        this.toastr.error(statusUpdateError);
        this.spinner.hide();
        this.isSaving = false;
        return;
      }
    }
    if (this.isQuote && this.editAppointmentService.appointmentDetails.appointmentType == "Quote" && this.SelectedStatus == Enums.WOStatus.Cancelled) {
      // nothing validaion.
    } else {
      if ((this.SelectedStatus != null || this.SelectedStatus != undefined)) {

        this.isCurrentAppointmentOnHold = (this.contactDetails.workorderStatusId === Enums.WOStatus.OnHold) ? true : false;
        let approvedemand = Constant.ApprovedDemand;
        let atleastOneDemandApproved = false;

        for (let value of viewModel.AppointmentDemandList) {
          if (!(!this.isQuote && value.SentForCustomerApproval === true && value.customerReply != "Approved")) {
            atleastOneDemandApproved = true;
            break;
          }
        }
        if (!atleastOneDemandApproved && !this.editAppointmentService.isExported) {
          this.toastr.error(approvedemand);
          this.spinner.hide();
          this.isSaving = false;
          return;
        }
      }
    }
    this.spinner.show();
    //To Get latest itemgroup code and cost price to calculate item price changes done by dharmendra on 9 Oct 2024
    viewModel = await this.workOrderService.GetPartCostAndItemGroupCode(viewModel, false);
    // Finish to get part price.
    await this.appointmentService.UpdateAppointment(viewModel)
      .then(async (response) => {
        // Captured before any of the resets below run, so it still reflects whether THIS save
        // was the "SSM Import order" save, regardless of what isExported is by the time the
        // nested GetServiceDetail callback below actually executes.
        const wasImportedFromSSM = this.editAppointmentService.isExported;
        if (response.responseObject.result) {
          //Show dms response failed message
          if (!this.empty(response.responseObject.result.dmsFailedMessage)) {
            this.toastr.error(response.responseObject.result.dmsFailedMessage);
          }
          if (response.responseObject.result?.errorCode === Enums.ErrorCodes.DataNotFound) {
            this.spinner.hide();
            this.isSaving = false;
            let errorMessage = this.translate.instant("lblAppointmentDeleted");
            this.toastr.error(errorMessage);
          } 
          else if(response.responseObject.result?.isAlreadyModifiedAppointment)
          {
            this.spinner.hide();
            this.isSaving = false;
            let errorMessage = this.translate.instant("lblAppointmentAlreadyModified");
            this.toastr.error(errorMessage);
          }
          else {

            this.spinner.hide();
            this.workOrderService.isUpdateAppointment = false;
            if (response.responseObject.result.ifsWorkOrderStatusId && response.responseObject.result.appointmentStatusId) {
              this.editAppointmentService.appointmentDetails.bookedDateTime = response.responseObject.result.bookedDateTime;
              this.editAppointmentService.appointmentDetails.workOrderStatusId = response.responseObject.result.ifsWorkOrderStatusId;
              this.editAppointmentService.appointmentDetails.workOrderStatusColor = response.responseObject.result.workOrderStatusColor;
              this.editAppointmentService.appointmentDetails.workOrderStatus = response.responseObject.result.workorderStatus;
              this.editAppointmentService.appointmentDetails.appointmentStatusId = response.responseObject.result.appointmentStatusId;
              this.editAppointmentService.appointmentDetails.appointmentStatusColor = response.responseObject.result.appointmentStatusColor;
              this.editAppointmentService.appointmentDetails.workOrderNo = response.responseObject.result.workOrderNumber;
              this.editAppointmentService.appointmentDetails.appointmentStatus = response.responseObject.result.appointmentStatus;
              this.editAppointmentService.appointmentDetails.appointmentType = response.responseObject.result.appointmentType;
              this.editAppointmentService.appointmentDetails.kilometer = response.responseObject.result.kilometer;
              this.editAppointmentService.appointmentDetails.contactInfo = response.responseObject.result.contactInfo;
              this.editAppointmentService.appointmentDetails.singlePhoneNo = response.responseObject.result.singlePhoneNo;
              this.editAppointmentService.appointmentDetails.paymentMethodCode = response.responseObject.result.paymentMethodCode;
              this.editAppointmentService.appointmentDetails.paymentTermsCode = response.responseObject.result.paymentTermsCode;
              this.editAppointmentService.appointmentDetails.information = response.responseObject.result.information;
              this.editAppointmentService.appointmentDetails.invoiceReference = response.responseObject.result.invoiceReference;
              this.editAppointmentService.appointmentDetails.discountCode = response.responseObject.result.discountCode;
              this.contactDetails.documentPartStatus = response.responseObject.result.documentPartStatus;
              this.contactDetails.appointmentChangeVersion = response.responseObject.result.appointmentChangeVersion;
              this.editAppointmentService.appointmentDetails.documentPartStatus = response.responseObject.result.documentPartStatus;
              this.editAppointmentService.appointmentDetails.dmsDocumentPartStatus = response.responseObject.result.dmsDocumentPartStatus;
              this.appointmentDetails.documentPartStatus = this.contactDetails.documentPartStatus;
              this.SelectedDocumentPartStatus = this.contactDetails.documentPartStatus;
              this.editAppointmentService.appointmentDetails.isCustomerWaiting = response.responseObject.result.isCustomerWaiting;
              this.editAppointmentService.appointmentDetails.isRentalCarSelected = response.responseObject.result.isRentalCarSelected;
              this.editAppointmentService.appointmentDetails.rentalVehicleId = response.responseObject.result.rentalVehicleId;
              this.commonService.IsonHoldStatus = response.responseObject.result.appointmentStatusId === Enums.WOStatus.OnHold ? true : false;
              //on save sharebox reminder message.
              if(this.editAppointmentService.appointmentDetails.bookedDate!= null &&(this.editAppointmentService.appointmentDetails.isKeyDrop!=response.responseObject.result.isKeyDrop || 
                this.editAppointmentService.appointmentDetails.isAutoKey!=response.responseObject.result.isAutoKey)
              ){ 
                this.onShiftAppointment.emit();
              }
              this.editAppointmentService.appointmentDetails.isKeyDrop = response.responseObject.result.isKeyDrop;
              this.editAppointmentService.appointmentDetails.isAutoKey = response.responseObject.result.isAutoKey;
              this.editAppointmentService.appointmentDetails.isCheckIn = response.responseObject.result.isCheckIn;
              this.editAppointmentService.appointmentDetails.deliveryTime = response.responseObject.result.deliveryTime;
              this.editAppointmentService.appointmentDetails.finishedTime = response.responseObject.result.finishedTime;
              this.appointmentDetails.bookedDateTime = this.editAppointmentService.appointmentDetails.bookedDateTime;
              this.appointmentBookedDate = this.appointmentDetails.bookedDateTime ? new Date(this.appointmentDetails.bookedDateTime + 'Z') : null;
              this.appointmentDetails.workOrderStatusId = this.editAppointmentService.appointmentDetails.workOrderStatusId;
              this.appointmentDetails.workOrderStatusColor = this.editAppointmentService.appointmentDetails.workOrderStatusColor;
              this.appointmentDetails.workOrderStatus = this.editAppointmentService.appointmentDetails.workOrderStatus;
              this.appointmentDetails.appointmentStatusId = this.editAppointmentService.appointmentDetails.appointmentStatusId;
              this.appointmentDetails.appointmentStatusColor = this.editAppointmentService.appointmentDetails.appointmentStatusColor;
              this.appointmentDetails.workOrderNo = this.editAppointmentService.appointmentDetails.workOrderNo;
              this.appointmentDetails.appointmentType = this.editAppointmentService.appointmentDetails.appointmentType;
              this.IsonHoldStatus = this.appointmentDetails.workOrderStatusId === Enums.WOStatus.OnHold ? true : false;
              this.isQuote = this.editAppointmentService.appointmentDetails.appointmentType == "Quote" ? true : false;
              if (!this.isQuote) {
                this.editAppointmentService.isDownloadOffer = false;
              }

              if (
                (this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.WorkRequest) &&
              (this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.InvoicePaid) &&
              (this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.Invoiceready) &&
              (this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.Cancelled) &&
                (this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.Closed) &&
                (this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.OnHold) &&
                !this.editAppointmentService.appointmentDetails.isFromArchive)
            {
              this.commonService.isShowGenerateAndSendCheckInButton = true;
              if(this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.Prepared || this.contactDetails?.isCheckInDoneByCustomer)
                {
                  this.commonService.isShowGenerateTrackerButton = true;
                }
                else{
                  this.commonService.isShowGenerateTrackerButton = false;
                }
      
            }
            else{
              this.commonService.isShowGenerateTrackerButton = false;
              this.commonService.isShowGenerateAndSendCheckInButton = false;
            }



              this.commonService.appointmentUpdatedDate = new Date();
              this.commonService.campaignService = response.responseObject.result.campaignService;
              this.commonService.contactDetails.isAuthorizedByServiceAdvisor = response.responseObject.result.isAuthorizedByServiceAdvisor;
              this.editAppointmentService.appointmentDetails.workorderStatusId = this.editAppointmentService.appointmentDetails.workOrderStatusId
              this.editAppointmentService.appointmentDetails.workorderStatusColor = this.editAppointmentService.appointmentDetails.workOrderStatusColor
              this.editAppointmentService.appointmentDetails.workorderStatus = this.editAppointmentService.appointmentDetails.workOrderStatus
              //refresh tab when quote/offer status change to prepared (order)
              if (this.SelectedStatus === Enums.WOStatus.Prepared) {
                this.isRefreshTab.emit(true);
              }
              this.SelectedStatus = null;
              this.contactDetails.bookedDateTime = response.responseObject.result.bookedDateTime;
              this.appointmentStatusName = this.editAppointmentService.appointmentDetails.appointmentStatus;
              this.previousStatus = this.appointmentDetails.workOrderStatusId;
              this.previousDocumentStatus = this.appointmentDetails.documentPartStatus;
              if (this.appointmentDetails.workOrderStatusId === Enums.WOStatus.Closed || this.appointmentDetails.workOrderStatusId === Enums.WOStatus.Cancelled) {
                this.SelectedStatus = this.appointmentDetails.workOrderStatusId;
                this.StatusDisabled = true;
              }
              if (this.appointmentDetails.appointmentType === AppointmentType.OFFER || this.appointmentDetails.workOrderStatusId === Enums.WOStatus.Workdone || this.appointmentDetails.workOrderStatusId === Enums.WOStatus.Invoiceready || this.appointmentDetails.workOrderStatusId === Enums.WOStatus.InvoicePaid || this.appointmentDetails.workOrderStatusId === Enums.WOStatus.Closed) {
                this.showPdf.emit(1);
              }
              if (this.appointmentDetails.workOrderStatusId === Enums.WOStatus.Workdone || this.appointmentDetails.workOrderStatusId === Enums.WOStatus.Mechanicdone || this.appointmentDetails.workOrderStatusId === Enums.WOStatus.Invoiceready) {
                this.showPdf.emit(2);
              }
              this.IsDisableBookedDate = this.appointmentDetails.workOrderStatusId === Enums.WOStatus.Prepared ? false : true;
              if (this.appointmentDetails.workOrderStatusId !== Enums.WOStatus.WorkRequest && this.appointmentDetails.workOrderStatusId !== Enums.WOStatus.Cancelled) {
                this.editAppointmentService.AppointmentGenericTabs = [];
                this.addAppointmentTab(Enums.ApointmentModuleNames.WorkOrder);
                this.addAppointmentTab(Enums.ApointmentModuleNames.AdditionalWork);
                this.addAppointmentTab(Enums.ApointmentModuleNames.Planning);
                this.addAppointmentTab(Enums.ApointmentModuleNames.Communication);
                this.addAppointmentTab(Enums.ApointmentModuleNames.WorkOrderHistory);
                this.addAppointmentTab(Enums.ApointmentModuleNames.Documents);
                this.addAppointmentTab(Enums.ApointmentModuleNames.Updates);
                if (this.secureStorage.getKeyData('feature')) {
                  this.features = this.secureStorage.getKeyData('feature');
                  if (this.features?.length > 0) {
                    let feature = this.features.find(x => x.featureCode === Enums.FeatureCode.DWO)?.isActive
                    let isScriveActive = this.features.find(x => x.featureCode === Enums.FeatureCode.Scrive)?.isActive
                    let isInvoice = this.features.find(x => x.featureCode === Enums.FeatureCode.INVGN)?.isActive
                    if (feature) {
                      this.addAppointmentTab(Enums.ApointmentModuleNames.DWO);
                      this.addAppointmentTab(Enums.ApointmentModuleNames.Parking);
                    }
                  if(isScriveActive){
                    this.addAppointmentTab(Enums.ApointmentModuleNames.Documents);
                  }
                  if(isInvoice && this.userService?.currentUserValue?.userRoleMenuDetails?.find(x=>x.moduleId === Enums.ModuleNames.AllowInvoiceFeature)?.canView){
                    this.addAppointmentTab(Enums.ApointmentModuleNames.Invoie);
                  }
                  //sharebox
                  let shareBox = this.features.find(x => x.featureCode === Enums.FeatureCode.ShareBox)?.isActive;
                  if(shareBox){
                   // if(this.editAppointmentService.appointmentDetails.isAutoKey||this.editAppointmentService.appointmentDetails.isKeyDrop){
                      this.addAppointmentTab(Enums.ApointmentModuleNames.ShareboxLog);
                   // } 
                  } 
                }
              }
            }
            if(this.contactDetails.isRentalCarSelected){
              this.contactDetails.typeId = 0;
            }
              this.editAppointmentService.isEdit = this.getEditStatusofAppointment(this.editAppointmentService.appointmentDetails.workOrderStatusId);
            }
            if (viewModel.WorkOrderStatusId === Enums.WOStatus.Prepared) {
              this.appLinkService.GetCheckInUrl(viewModel.AppointmentGuid).then(x => {
                this.editAppointmentService.checkInURL = x?.checkInTinyUrl;
              }, _error => { this.spinner.hide(); });
            }
            if (this.isQuote) {
              let successMessage = this.translate.instant("lblQuoteSaved");
              this.toastr.success(successMessage);
            }
            else {
              let successMessage = this.translate.instant("lblAppointmentSaved");
              this.toastr.success(successMessage);
            }
            this.spinner.show();
            if (this.editAppointmentService.isExported) {
              let msg = this.translate.instant("lblSSMExportAPISuccess")
              this.toastr.success(msg)
            }
            this.editAppointmentService.exportedJson = "";
            this.editAppointmentService.isExported = false;
            this.editAppointmentService.exportedMpoData = "";
            let language = this.cookieservice.get('userSelectedLanguage')
            const languageCode = this.cookieservice.get('userSelectedLanguage');
            // Awaited (via Promise.all, preserving their original concurrent execution) so the
            // isSaving/isSavingAppointment guard doesn't release until the local demand/job model
            // has actually been resynced with server-assigned Ids - otherwise, on a slow connection,
            // a Save/auto-save fired in the gap before this refresh completed would still resend the
            // stale (Id=0) demand and duplicate it, even though the guard appeared to be released.
            await Promise.all([
            this.appointmentService.getStatusBrand(this.editAppointmentService.appointmentDetails.dealerId, viewModel.Id, language).then(res => {
              this.brandList = res.responseObject.brand;
              this.statusList = res.responseObject.statusModel;
              this.documentPartStatus = res.responseObject.documentParts;
              this.statusList.sort((a, b) => a.id > b.id ? -1 : 1);
              this.commonService.brandList = res.responseObject.brand;
              this.commonService.statusList = res.responseObject.statusModel
              this.commonService.documentPartStatus = res.responseObject.documentParts;
              this.commonService.statusList.sort((a, b) => a.id > b.id ? -1 : 1);
            }),
            this.appointmentService.GetServiceDetail(this.editAppointmentService.appointmentDetails.id, '', languageCode).then(data => {
              if (data.responseObject?.errorCount > 0) {
                this.spinner.hide();
                this.serviceDetail = {
                  totalPrice: 0,
                  totalTime: 0,
                  totalInvoicePrice: 0,
                  priceForDisply: '',
                  rentalCompanyMakeName: '',
                  appointmentDemandList: [],
                  appointmentJobDetailList: [],
                  appointmentJobList: [],
                  appointmentPriceDetails: [],
                }
                this.workOrderService.totalPrice = null;
                this.workOrderService.totalTime = null;
                this.workOrderService.totalInvoicePrice = null;
              }
              else {
                this.spinner.hide();
                this.serviceDetail = data.responseObject;
                this.mapIndexWithJobDetails();
                this.workOrderService.appointmentDemandList = this.serviceDetail.appointmentDemandList;
                this.workOrderService.appointmentJobList = this.serviceDetail.appointmentJobList;
                this.workOrderService.appointmentJobDetailList = this.serviceDetail.appointmentJobDetailList;
                this.editAppointmentService.appointmentDemandList = this.workOrderService.appointmentDemandList;
                this.editAppointmentService.appointmentJobDetailsList = this.workOrderService.appointmentJobDetailList;
                this.workOrderService.totalPrice = 0;
                this.workOrderService.totalPriceInclVAT = 0;
                this.workOrderService.totalInvoicePrice = 0;
                if (this.commonService.contactDetails.isRentalCarSelected) {
                  this.RentalCarModel = this.serviceDetail.rentalCompanyMakeName;
                  this.RentalCarPrice = this.serviceDetail.priceForDisply;
                  this.commonService.RentalCarModel = this.serviceDetail.rentalCompanyMakeName;
                  this.commonService.RentalCarPrice = this.serviceDetail.priceForDisply;
                } else {
                  this.RentalCarModel = null;
                  this.RentalCarPrice = null;
                  this.commonService.RentalCarModel = null;
                  this.commonService.RentalCarPrice = null;
                }
                this.cdref.detectChanges()
                this.workOrderService.totalTime = this.serviceDetail.totalTime;
                if (this.serviceDetail.taxDetail) {
                  this.workOrderService.taxDetail = this.serviceDetail.taxDetail;
                  this.workOrderService.totalPrice = this.serviceDetail.taxDetail.totalPriceInclTAX;
                  this.workOrderService.totalInvoicePrice = this.serviceDetail.taxDetail.totalInvoicePrice;
                  this.workOrderService.totalPriceInclVAT = this.serviceDetail.taxDetail.totalPriceInclVAT;
                  this.commonService.contactDetails.mileageUpdateBy = this.serviceDetail.taxDetail.mileageUpdateBy;
                  this.commonService.contactDetails.mileageUpdateDate = this.serviceDetail.taxDetail.mileageUpdateDate ? Utility.GetFormattedDateTime(Utility.ConvertUTCDateToLocalDate(this.serviceDetail.taxDetail.mileageUpdateDate)) : null;
                  this.workOrderService.getOverallAmountForAppointment();
                }
                this.formattedTotalTime = Number(this.workOrderService.totalTime).toFixed(2);
                this.workOrderService.appointmentJobDetailToUpdate = this.serviceDetail.appointmentJobDetailList.slice();
                this.addFilterSelectedVariable(false);
                if (wasImportedFromSSM) {
                  this.correctSSMImportedPartPrices();
                }
              }

            })
            ]);
            this.workOrderService.isRentalCarUpdated = false;
            this.onGetContactDetails.emit(this.editAppointmentService.appointmentDetails);
            this.spinner.hide();
            this.isSaving = false;
            if (this.isCurrentAppointmentOnHold && this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.Cancelled) {
              let msg = this.translate.instant("lblRescheduleAppointmentMessage")
              msg += this.contactDetails.workOrderNo;
              let modelHeadermsg = this.translate.instant("lblActivateWorkOrder");
              const modalRef = this.modalService.open(NgInfoModalContent);
              modalRef.componentInstance.modelHeader = modelHeadermsg;
              modalRef.componentInstance.modelBody = msg;
              modalRef.result.then((_result) => {
                // This is intentional
              }, (reason) => {
                this.popupCloseResult = this.commonService.getDismissReason(reason);
              });
            }
          }
        }
        else {
          this.spinner.hide();
          this.isSaving = false;
          let errorMessage = this.translate.instant("lblErrorMessage");
          this.toastr.error(errorMessage);
        }
        this.editAppointmentService.exportedJson = "";
        this.editAppointmentService.isExported = false;
        //do not display btn on below status
        this.isShowGenerateTrackerButton = (this.appointmentDetails.workOrderStatusId === Enums.WOStatus.Waitingforcustomer ||
          this.appointmentDetails.workOrderStatusId === Enums.WOStatus.Prepared ||
          this.appointmentDetails.workOrderStatusId === Enums.WOStatus.WorkRequest ||
          this.appointmentDetails.workOrderStatusId === Enums.WOStatus.Closed ||
          this.appointmentDetails.workOrderStatusId === Enums.WOStatus.InvoicePaid ||
          this.appointmentDetails.workOrderStatusId === Enums.WOStatus.Invoiceready ||
          this.appointmentDetails.workOrderStatusId === Enums.WOStatus.Cancelled
        ) ? false : true
      });
    if (isclose) {
      this.CheckDataSyncedOnAppointment('close');
    }
    } finally {
      this.workOrderService.endSave(appointmentId);
    }
  }

  // Runs only after a "SSM Import order" save. SSM-imported Material lines are priced from SSM's
  // own quote by the backend (MapSSMResponse); this silently re-prices them from Incadea afterward,
  // via the same Parts/GetPartCostPriceDetails endpoint already used for manually-added parts, then
  // persists the correction with a second, normal (non-SSM) save. Runs in the background - it must
  // never surface an error or block the UI, since the appointment is already saved successfully by
  // the time this runs.
  private async correctSSMImportedPartPrices(): Promise<void> {
    try {
      const updated = await this.workOrderService.RefreshImportedPartPricesFromIncadea(
        this.workOrderService.appointmentJobDetailToUpdate,
        this.workOrderService.appointmentDemandList
      );
      if (!updated) {
        return;
      }
      const correctedViewModel = this.workOrderService.MapToViewModel(true, false);

      await this.appointmentService.UpdateAppointment(correctedViewModel)
      .then(async (response) => {
        if (response.responseObject.result) {
          //Show dms response failed message
          if(!this.empty(response.responseObject.result.dmsFailedMessage)){
            this.toastr.error(response.responseObject.result.dmsFailedMessage);
          }
          if(response.responseObject.result?.errorCode === Enums.ErrorCodes.DataNotFound)
          {
            this.spinner.hide();
            let errorMessage = this.translate.instant("lblAppointmentDeleted");
            this.toastr.error(errorMessage);
            return;
          }
          if (response.responseObject.result?.isAlreadyModifiedAppointment)
          {
            this.spinner.hide();
            let errorMessage = this.translate.instant("lblAppointmentAlreadyModified");
            this.toastr.error(errorMessage);
            return;
          }
            this.workOrderService.contactDetails.appointmentChangeVersion = response.responseObject.result.appointmentChangeVersion;
            this.workOrderService.contactDetails.needAttention = response.responseObject.result.needAttention;
            
            const languageCode = this.cookieservice.get('userSelectedLanguage');
            const data = await this.appointmentService.GetServiceDetail(this.editAppointmentService.appointmentDetails.id, '', languageCode);
            if (data?.responseObject && !(data.responseObject.errorCount > 0)) {
              this.serviceDetail = data.responseObject;
              this.mapIndexWithJobDetails();
              this.workOrderService.appointmentDemandList = this.serviceDetail.appointmentDemandList;
              this.workOrderService.appointmentJobList = this.serviceDetail.appointmentJobList;
              this.workOrderService.appointmentJobDetailList = this.serviceDetail.appointmentJobDetailList;
              this.editAppointmentService.appointmentDemandList = this.workOrderService.appointmentDemandList;
              this.editAppointmentService.appointmentJobDetailsList = this.workOrderService.appointmentJobDetailList;
              this.workOrderService.appointmentJobDetailToUpdate = this.serviceDetail.appointmentJobDetailList.slice();
              if (this.serviceDetail.taxDetail) {
                this.workOrderService.taxDetail = this.serviceDetail.taxDetail;
                this.workOrderService.totalPrice = this.serviceDetail.taxDetail.totalPriceInclTAX;
                this.workOrderService.totalInvoicePrice = this.serviceDetail.taxDetail.totalInvoicePrice;
                this.workOrderService.totalPriceInclVAT = this.serviceDetail.taxDetail.totalPriceInclVAT;
                this.workOrderService.getOverallAmountForAppointment();
              }
              this.cdref.detectChanges();
            }

        }
        this.spinner.hide();
      }, _error => {
        this.spinner.hide();
      })
   
    } catch (e) {
      console.warn('SSM-imported part price correction from Incadea failed; SSM price remains saved.', e);
    }
  }

  addAppointmentTab(tabId: number) {
    let tab = AppointmentGenericTabs.find(x => x.id == tabId);
    if (!this.editAppointmentService.AppointmentGenericTabs.includes(tab)) {
      this.editAppointmentService.AppointmentGenericTabs.push(tab);
    }
    this.editAppointmentService.AppointmentGenericTabs = this.editAppointmentService.AppointmentGenericTabs.sort((x, y) => x.id - y.id);
  }
  calculateDateTime(selectedDate, Hour, Minute): Date {
    let dateArray = selectedDate.split('.');
    let date = +dateArray[0];
    let month = +dateArray[1];
    let year = +dateArray[2];
    return new Date(year, month - 1, date, +Hour, +Minute);
  }

  public generateStatusTrackerLink(data) {
    let model = {
      AppointmentGuid: data.AppointmentGuid
    };
    this.appLinkService.AddTrackerLink(model)
      .then(
        _res => {
          this.appLinkService.GetTrackerLink(model.AppointmentGuid).then(x => {
            this.editAppointmentService.trackerURL = x;
          }, _error => { this.spinner.hide(); })

          let successMessage = this.translate.instant("lblTrackerLinkGenerated");
          this.toastr.success(successMessage);

        },
        err => {
          console.error('HTTP Error', err);
        }
      );
  }


  getEditStatusofAppointment(statusId: number) {
    let canEdit = false;
    if (this.appointmentService.appointmentStatusList && this.appointmentService.appointmentStatusList.length > 0) {
      let editable = this.appointmentService.appointmentStatusList.find(x => x.id === statusId);
      const appointment = this.editAppointmentService.appointmentDetails;
      if ((appointment.appointmentType === Enums.AppointmentType.OFFER && appointment.isQuoteExipred) || this.editAppointmentService.isOpenByOtherUser) {
        return canEdit;
      }
      else if (editable?.isEditable) {
        canEdit = this.isOpenFromPlanning ? false: (this.editAppointmentService.appointmentDetails.isFromArchive ? false : (this.isViewAppointmentFromWAR? false : true));
        this.editAppointmentService.isEdit = canEdit;
      }
    }
    return canEdit;
  }


  async OnClose() {
    //Commented by dharmendra on 19 July. due to taking too much time too load and service and parts added in planner side when we select, after pressing
    //save button it will sync to DMS.
    // await this.SaveAppointmentData();
    this.activeModal.close({
      success: false
    });
  }

  CheckDataSyncedOnAppointment(cause: any) {
    this.commonService.isSaveAndClose = true;
    this.commonService.isPopupClose = true;
    this.closeFromAppiontmentWO.emit(true);
  }

  viewCustomer(cType, e: Event) {
    e.stopPropagation();
    if (cType == 1) {
      this.serviceCustomer.customerId = this.contactDetails.customerId;
      this.serviceCustomer.customerNo = this.contactDetails.customerNo;
      this.serviceCustomer.customerName = this.contactDetails.customerName;
      this.serviceCustomer.firstName = this.contactDetails.firstName;
      this.serviceCustomer.lastName = this.contactDetails.lastName;
    } else if (cType == 2) {
      this.serviceCustomer.customerId = this.contactDetails.billToCustomerId;
      this.serviceCustomer.customerNo = this.contactDetails.billtoCustomerNo;
      this.serviceCustomer.customerName = this.contactDetails.billToCustomerName;
      this.serviceCustomer.firstName = this.contactDetails.billToFirstName;
      this.serviceCustomer.lastName = this.contactDetails.billToLastName;
    }
    const modalref = this.modalService.open(ViewCustomerComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.componentInstance.isFromServiceAdvisor = false;
    modalref.componentInstance.fromVehicleScreen = false;
    modalref.componentInstance.fromVehicleCustomerDetails = false;
    modalref.result.then(
      (response) => {
        this.customerRefreshData();
      },
    );

  }
  viewVehicle(e: Event) {
    e.stopPropagation();
    this.serviceVehicle.vehicleId = parseInt(this.contactDetails.vehicleId);
    this.serviceVehicle.licensePlate = this.contactDetails.licensePlate;
    this.serviceVehicle.make = this.contactDetails.companyMakeCode;
    this.serviceVehicle.model = this.contactDetails.companyModel;
    this.serviceVehicle.vinNo = this.contactDetails.chassisNo;
    this.serviceVehicle.vehicleGuid = '';
    const modalref = this.modalService.open(EditVehicleComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.componentInstance.fromHistory = false;
    modalref.componentInstance.fromWorkOrder = false;
    modalref.result.then(
      (response) => {

      },
    );
  }

  reOpenAppointment(content: any) {
    this.modalService.open(content, { size: 'md', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    }, async (reason) => {
      if (reason) {
        await this.appointmentService.ReOpenAppointment(this.editAppointmentService.appointmentDetails.workOrderNo).then(result => {
          if(result.isSuccess){
            let successMessage = this.translate.instant("lblAppointmentReOpenedSuccessFully");
            this.toastr.success(successMessage);
            if(reason){
              this.modalService.dismissAll();
              this.multiStackPopupService.OpenAppointment(result.retValue, false);
            }
            this.appointmentService.isRefreshListing = true;
          }
          else{
            let errorMessage = this.translate.instant("lblAppointmentDetailNotFound");
            this.toastr.error(errorMessage);
          }
        });
      }
      this.modalService.dismissAll();
    });
  }
}
